<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขข้อมูลรหัสชนิดสินค้า' : 'เพิ่มข้อมูลรหัสชนิดสินค้า' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="form">
    <div class="row mb-3">
      <div class="col-sm-4"><label for="productGroupId" class="form-label mb-0 required">กลุ่มสินค้า</label></div>
      <div class="col-sm-8">
        <select id="productGroupId" class="form-select form-select-sm" formControlName="productGroupId">
          <option [ngValue]="null">กรุณาเลือก</option>
          @for (item of productGroups; track item.id ?? $index) {
            <option [ngValue]="item.id">{{ item.title }}</option>
          }
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="title" class="form-label mb-0 required">ชื่อชนิดสินค้า</label></div>
      <div class="col-sm-8"><input id="title" type="text" class="form-control form-control-sm" formControlName="title"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="productCode" class="form-label mb-0 required">รหัสชนิดสินค้า</label></div>
      <div class="col-sm-8"><input id="productCode" type="text" class="form-control form-control-sm" formControlName="productCode" maxlength="11"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="fullName" class="form-label mb-0">ชื่อสามัญ</label></div>
      <div class="col-sm-8"><input id="fullName" type="text" class="form-control form-control-sm" formControlName="fullName" placeholder="ชื่อสามัญ"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="scienceName" class="form-label mb-0">ชื่อวิทยาศาสตร์</label></div>
      <div class="col-sm-8"><input id="scienceName" type="text" class="form-control form-control-sm" formControlName="scienceName" placeholder="ชื่อวิทยาศาสตร์"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="state" class="form-label mb-0">สถานะ</label></div>
      <div class="col-sm-8">
        <select id="state" class="form-select form-select-sm" formControlName="state">
          <option [ngValue]="1">เผยแพร่</option>
          <option [ngValue]="0">ไม่เผยแพร่</option>
        </select>
      </div>
    </div>

    @if (isEditMode) {
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedBy" class="form-label mb-0">ผู้บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedBy" class="form-control form-control-sm" [value]="recordedByDisplay" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedAt" class="form-label mb-0">วันที่บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedAt" class="form-control form-control-sm" [value]="recordedAtDisplay" readonly></div>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก</button>
  }
</div>
